import type { PageProps, PaymentOrchestrationPageProps } from "@/types";
import React, { FC, useRef } from "react";
import {
  PaymentOrchestrationForeignExchangeAndGlobalLiquidity,
  PaymentOrchestrationHero,
  PaymentOrchestrationLastMileConnectivity,
  PaymentOrchestrationSecureFunding,
  PaymentOrchestrationTransactionMonitoring,
  PaymentOrchestrationUniversalPaymentAccount,
} from "../payment-orchestration";
import { ContentManager } from "../content-manager";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";
import { NextPage } from "../next-page";

export const PaymentOrchestration: FC<PageProps<
  PaymentOrchestrationPageProps
>> = (props) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <div>
      <PaymentOrchestrationHero
        label={props.meta.translation.solutions.hero.label}
        title={props.data.title}
        description={props.data.description}
        cover={props.data.cover}
      />
      <div ref={ref}>
        <SplitTextAnimation
          htmlElement={
            <ContentManager
              content={props.data.complianceConnector}
              className="paymentOrchestrationComplianceConnector--content"
            />
          }
          isInView={isInView}
        />
      </div>
      <PaymentOrchestrationUniversalPaymentAccount
        content={props.data.universalPaymentAccountContent}
        cover={props.data.universalPaymentAccountCover}
      />
      <PaymentOrchestrationSecureFunding
        content={props.data.secureFundingContent}
        list={props.data.secureFundingList}
      />
      <PaymentOrchestrationForeignExchangeAndGlobalLiquidity
        content={props.data.foreignExchangeAndGlobalLiquidityContent}
        cover={props.data.foreignExchangeAndGlobalLiquidityCover}
      />
      <PaymentOrchestrationLastMileConnectivity
        content={props.data.lastMileConnectivityContent}
        tags={props.data.lastMileConnectivityTags}
        cover={props.data.lastMileConnectivityCover}
      />
      <PaymentOrchestrationTransactionMonitoring
        content={props.data.transactionMonitoringContent}
        cover={props.data.transactionMonitoringCover}
      />
      <PaymentOrchestrationTransactionMonitoring
        content={props.data.smartPaymentRoutingContent}
        cover={props.data.smartPaymentRoutingCover}
      />
      <PaymentOrchestrationTransactionMonitoring
        content={props.data.idTokenizationContent}
        cover={props.data.idTokenizationCover}
      />
      <PaymentOrchestrationTransactionMonitoring
        content={props.data.globalDirectoryServiceContent}
        cover={props.data.globalDirectoryServiceCover}
      />
      <NextPage {...props.data.nextPage} />
    </div>
  );
};
